// Data from https://www.kaggle.com/datasets/maryanalyze/tables-on-transistor-count-wikipedia-page (Transistor_count_2.csv file)

const transistorCPUdata = [
  {
    name: 'MP944 (20-bit, 6-chip, 28 chips total)',
    number: 74_442,
    year: 1970,
    constructor: 'Garrett AiResearch',
    density: null,
  },
  {
    name: 'Intel 4004 (4-bit, 16-pin)',
    number: 2_25,
    year: 1971,
    constructor: 'Intel',
    density: 188,
  },
  {
    name: 'TMX 1795 (null-bit, 24-pin)',
    number: 3_078,
    year: 1971,
    constructor: 'Texas Instruments',
    density: 100.5,
  },
  {
    name: 'Intel 8008 (8-bit, 18-pin)',
    number: 3_5,
    year: 1972,
    constructor: 'Intel',
    density: 250,
  },
  {
    name: 'NEC μCOM-4 (4-bit, 42-pin)',
    number: 2_5,
    year: 1973,
    constructor: 'NEC',
    density: null,
  },
  {
    name: 'Toshiba TLCS-12 (12-bit)',
    number: 11_000,
    year: 1973,
    constructor: 'Toshiba',
    density: 340,
  },
  {
    name: 'Intel 4040 (4-bit, 16-pin)',
    number: 3,
    year: 1974,
    constructor: 'Intel',
    density: 250,
  },
  {
    name: 'Motorola 6800 (8-bit, 40-pin)',
    number: 4_1,
    year: 1974,
    constructor: 'Motorola',
    density: 256,
  },
  {
    name: 'Intel 8080 (8-bit, 40-pin)',
    number: 6,
    year: 1974,
    constructor: 'Intel',
    density: 300,
  },
  {
    name: 'TMS 1000 (4-bit, 28-pin)',
    number: 8,
    year: 1974,
    constructor: 'Texas Instruments',
    density: 730,
  },
  {
    name: 'MOS Technology 6502 (8-bit, 40-pin)',
    number: 4_528,
    year: 1975,
    constructor: 'MOS Technology',
    density: 216,
  },
  {
    name: 'Intersil IM6100 (12-bit, 40-pin; clone of PDP-8)',
    number: 4,
    year: 1975,
    constructor: 'Intersil',
    density: null,
  },
  {
    name: 'CDP 1801 (8-bit, 2-chip, 40-pin)',
    number: 5,
    year: 1975,
    constructor: 'RCA',
    density: null,
  },
  {
    name: 'RCA 1802 (8-bit, 40-pin)',
    number: 5,
    year: 1976,
    constructor: 'RCA',
    density: 185,
  },
  {
    name: 'Zilog Z80 (8-bit, 4-bit ALU, 40-pin)',
    number: 8_5,
    year: 1976,
    constructor: 'Zilog',
    density: 470,
  },
  {
    name: 'Intel 8085 (8-bit, 40-pin)',
    number: 6_5,
    year: 1976,
    constructor: 'Intel',
    density: 325,
  },
  {
    name: 'TMS9900 (16-bit)',
    number: 8,
    year: 1976,
    constructor: 'Texas Instruments',
    density: null,
  },
  {
    name: 'Bellmac-8 (8-bit)',
    number: 7,
    year: 1977,
    constructor: 'Bell Labs',
    density: null,
  },
  {
    name: 'Motorola 6809 (8-bit with some 16-bit features, 40-pin)',
    number: 9,
    year: 1978,
    constructor: 'Motorola',
    density: 430,
  },
  {
    name: 'Intel 8086 (16-bit, 40-pin)',
    number: 29,
    year: 1978,
    constructor: 'Intel',
    density: 880,
  },
  {
    name: 'Zilog Z8000 (16-bit)',
    number: 17_5,
    year: 1979,
    constructor: 'Zilog',
    density: null,
  },
  {
    name: 'Intel 8088 (16-bit, 8-bit data bus)',
    number: 29,
    year: 1979,
    constructor: 'Intel',
    density: 880,
  },
  {
    name: 'Motorola 68000 (16/32-bit, 32-bit registers, 16-bit  ALU)',
    number: 68,
    year: 1979,
    constructor: 'Motorola',
    density: 1_55,
  },
  {
    name: 'Intel 8051 (8-bit, 40-pin)',
    number: 50,
    year: 1980,
    constructor: 'Intel',
    density: null,
  },
  { name: 'WDC 65C02', number: 11_5, year: 1981, constructor: 'WDC', density: 1_92 },
  {
    name: 'ROMP (32-bit)',
    number: 45,
    year: 1981,
    constructor: 'IBM',
    density: null,
  },
  {
    name: 'Intel 80186 (16-bit, 68-pin)',
    number: 55,
    year: 1982,
    constructor: 'Intel',
    density: 920,
  },
  {
    name: 'Intel 80286 (16-bit, 68-pin)',
    number: 134,
    year: 1982,
    constructor: 'Intel',
    density: 2_73,
  },
  {
    name: 'WDC 65C816 (8/16-bit)',
    number: 22,
    year: 1983,
    constructor: 'WDC',
    density: 2_4,
  },
  { name: 'NEC V20', number: 63, year: 1984, constructor: 'NEC', density: null },
  {
    name: 'Motorola 68020 (32-bit; 114 pins used)',
    number: 190,
    year: 1984,
    constructor: 'Motorola',
    density: 2_2,
  },
  {
    name: 'Intel 80386 (32-bit, 132-pin; no cache)',
    number: 275,
    year: 1985,
    constructor: 'Intel',
    density: 2_64,
  },
  {
    name: 'ARM 1 (32-bit; no cache)',
    number: 25,
    year: 1985,
    constructor: 'Acorn',
    density: 500,
  },
  {
    name: 'Novix NC4016 (16-bit)',
    number: 16,
    year: 1985,
    constructor: 'Harris Corporation',
    density: null,
  },
  {
    name: 'SPARC MB86900 (32-bit; no cache)',
    number: 110,
    year: 1986,
    constructor: 'Fujitsu',
    density: null,
  },
  {
    name: 'NEC V60 (32-bit; no cache)',
    number: 375,
    year: 1986,
    constructor: 'NEC',
    density: null,
  },
  {
    name: 'ARM 2 (32-bit, 84-pin; no cache)',
    number: 27,
    year: 1986,
    constructor: 'Acorn',
    density: 890,
  },
  {
    name: 'Z80000 (32-bit; very small cache)',
    number: 91,
    year: 1986,
    constructor: 'Zilog',
    density: null,
  },
  {
    name: 'NEC V70 (32-bit; no cache)',
    number: 385,
    year: 1987,
    constructor: 'NEC',
    density: null,
  },
  {
    name: 'Hitachi Gmicro/200',
    number: 730,
    year: 1987,
    constructor: 'Hitachi',
    density: null,
  },
  {
    name: 'Motorola 68030 (32-bit, very small caches)',
    number: 273,
    year: 1987,
    constructor: 'Motorola',
    density: 2_68,
  },
  {
    name: "TI Explorer's 32-bit Lisp machine chip",
    number: 553,
    year: 1987,
    constructor: 'Texas Instruments',
    density: null,
  },
  {
    name: 'DEC WRL MultiTitan',
    number: 180,
    year: 1988,
    constructor: 'DEC WRL',
    density: 2_95,
  },
  {
    name: 'Intel i960 (32-bit, 33-bit memory subsystem, no cache)',
    number: 250,
    year: 1988,
    constructor: 'Intel',
    density: null,
  },
  {
    name: 'Intel i960CA (32-bit, cache)',
    number: 600,
    year: 1989,
    constructor: 'Intel',
    density: 4_2,
  },
  {
    name: 'Intel i860 (32/64-bit, 128-bit SIMD, cache, VLIW)',
    number: 1_000_000,
    year: 1989,
    constructor: 'Intel',
    density: null,
  },
  {
    name: 'Intel 80486 (32-bit, 4 KB cache)',
    number: 1_180_235,
    year: 1989,
    constructor: 'Intel',
    density: 6_822,
  },
  {
    name: 'ARM 3 (32-bit, 4 KB cache)',
    number: 310,
    year: 1989,
    constructor: 'Acorn',
    density: 3_6,
  },
  {
    name: 'POWER1 (9-chip module, 72 kB of cache)',
    number: 6_900_000,
    year: 1990,
    constructor: 'IBM',
    density: 5_375,
  },
  {
    name: 'Motorola 68040 (32-bit, 8 KB caches)',
    number: 1_200_000,
    year: 1990,
    constructor: 'Motorola',
    density: 7_9,
  },
  {
    name: 'R4000 (64-bit, 16 KB of caches)',
    number: 1_350_000,
    year: 1991,
    constructor: 'MIPS',
    density: 6_34,
  },
  {
    name: 'ARM 6 (32-bit, no cache for this 60 variant)',
    number: 35,
    year: 1991,
    constructor: 'ARM',
    density: null,
  },
  {
    name: 'Hitachi SH-1 (32-bit, no cache)',
    number: 600,
    year: 1992,
    constructor: 'Hitachi',
    density: 6,
  },
  {
    name: 'Intel i960CF (32-bit, cache)',
    number: 900,
    year: 1992,
    constructor: 'Intel',
    density: 7_2,
  },
  {
    name: 'DEC Alpha 21064 (64-bit, 290-pin; 16 KB of caches)',
    number: 1_680_000,
    year: 1992,
    constructor: 'DEC',
    density: 7_19,
  },
  {
    name: 'Hitachi HARP-1 (32-bit, cache)',
    number: 2_800_000,
    year: 1993,
    constructor: 'Hitachi',
    density: 10_5,
  },
  {
    name: 'Pentium (32-bit, 16 KB of caches)',
    number: 3_100_000,
    year: 1993,
    constructor: 'Intel',
    density: 10_5,
  },
  {
    name: 'POWER2 (8-chip module, 288 kB of cache)',
    number: 23_037_000,
    year: 1993,
    constructor: 'IBM',
    density: 18_923,
  },
  {
    name: 'ARM700 (32-bit; 8 KB cache)',
    number: 578_977,
    year: 1994,
    constructor: 'ARM',
    density: 8_451,
  },
  {
    name: 'MuP21 (21-bit, 40-pin; includes video)',
    number: 7,
    year: 1994,
    constructor: 'Offete Enterprises',
    density: null,
  },
  {
    name: 'Motorola 68060 (32-bit, 16 KB of caches)',
    number: 2_500_000,
    year: 1994,
    constructor: 'Motorola',
    density: 11_5,
  },
  {
    name: 'PowerPC 601 (32-bit, 32 KB of caches)',
    number: 2_800_000,
    year: 1994,
    constructor: 'Apple/IBM/Motorola',
    density: 23,
  },
  {
    name: 'PowerPC 603 (32-bit, 16 KB of caches)',
    number: 1_600_000,
    year: 1994,
    constructor: 'Apple/IBM/Motorola',
    density: 18_9,
  },
  {
    name: 'PowerPC 603e (32-bit, 32 KB of caches)',
    number: 2_600_000,
    year: 1995,
    constructor: 'Apple/IBM/Motorola',
    density: 26_5,
  },
  {
    name: 'Alpha 21164 EV5 (64-bit, 112 kB cache)',
    number: 9_300_000,
    year: 1995,
    constructor: 'DEC',
    density: 31_14,
  },
  {
    name: 'SA-110 (32-bit, 32 KB of caches)',
    number: 2_500_000,
    year: 1995,
    constructor: 'Acorn/DEC/Apple',
    density: 50,
  },
  {
    name: 'Pentium Pro (32-bit, 16 KB of caches; L2 cache on-package, but on separate die)',
    number: 5_500_000,
    year: 1995,
    constructor: 'Intel',
    density: 18,
  },
  {
    name: 'PA-8000 64-bit, no cache',
    number: 3_800_000,
    year: 1995,
    constructor: 'HP',
    density: 11_3,
  },
  {
    name: 'Alpha 21164A EV56 (64-bit, 112 kB cache)',
    number: 9_660_000,
    year: 1996,
    constructor: 'DEC',
    density: 46_26,
  },
  {
    name: 'AMD K5 (32-bit, caches)',
    number: 4_300_000,
    year: 1996,
    constructor: 'AMD',
    density: 17,
  },
  {
    name: 'Hitachi SH-4 (32-bit, caches)',
    number: 10_000_000,
    year: 1997,
    constructor: 'Hitachi',
    density: 238_000,
  },
  {
    name: 'Pentium II Klamath (32-bit, 64-bit SIMD, caches)',
    number: 7_500_000,
    year: 1997,
    constructor: 'Intel',
    density: 39,
  },
  {
    name: 'AMD K6 (32-bit, caches)',
    number: 8_800_000,
    year: 1997,
    constructor: 'AMD',
    density: 54,
  },
  {
    name: 'F21 (21-bit; includes e.g. video)',
    number: 15,
    year: 1997,
    constructor: 'Offete Enterprises',
    density: null,
  },
  {
    name: 'AVR (8-bit, 40-pin; w/memory)',
    number: 140_000,
    year: 1997,
    constructor: 'Nordic VLSI/Atmel',
    density: null,
  },
  {
    name: 'Pentium II Deschutes (32-bit, large cache)',
    number: 7_500_000,
    year: 1998,
    constructor: 'Intel',
    density: 66,
  },
  {
    name: 'Alpha 21264 EV6 (64-bit)',
    number: 15_200_000,
    year: 1998,
    constructor: 'DEC',
    density: 48_4,
  },
  {
    name: 'Alpha 21164PC PCA57 (64-bit, 48 kB cache)',
    number: 5_700_000,
    year: 1998,
    constructor: 'Samsung',
    density: 56_7,
  },
  {
    name: 'ARM 9TDMI (32-bit, no cache)',
    number: 111,
    year: 1999,
    constructor: 'Acorn',
    density: 23_1,
  },
  {
    name: 'Pentium III Katmai (32-bit, 128-bit SIMD, caches)',
    number: 9_500_000,
    year: 1999,
    constructor: 'Intel',
    density: 74,
  },
  {
    name: 'Emotion Engine (64-bit, 128-bit SIMD, cache)',
    number: 13_500_000,
    year: 1999,
    constructor: 'Sony/Toshiba',
    density: 56_3,
  },
  {
    name: 'Pentium II Mobile Dixon (32-bit, caches)',
    number: 27_400_000,
    year: 1999,
    constructor: 'Intel',
    density: 152,
  },
  {
    name: 'AMD K6-III (32-bit, caches)',
    number: 21_300_000,
    year: 1999,
    constructor: 'AMD',
    density: 181,
  },
  {
    name: 'AMD K7 (32-bit, caches)',
    number: 22_000_000,
    year: 1999,
    constructor: 'AMD',
    density: 120,
  },
  {
    name: 'Gekko (32-bit, large cache)',
    number: 21_000_000,
    year: 2000,
    constructor: 'IBM/Nintendo',
    density: 490_000,
  },
  {
    name: 'Pentium III Coppermine (32-bit, large cache)',
    number: 21_000_000,
    year: 2000,
    constructor: 'Intel',
    density: 263,
  },
  {
    name: 'Pentium 4 Willamette (32-bit, large cache)',
    number: 42_000_000,
    year: 2000,
    constructor: 'Intel',
    density: 194,
  },
  {
    name: 'SPARC64 V (64-bit, large cache)',
    number: 191_000_000,
    year: 2001,
    constructor: 'Fujitsu',
    density: 659,
  },
  {
    name: 'Pentium III Tualatin (32-bit, large cache)',
    number: 45_000_000,
    year: 2001,
    constructor: 'Intel',
    density: 556,
  },
  {
    name: 'Pentium 4 Northwood (32-bit, large cache)',
    number: 55_000_000,
    year: 2002,
    constructor: 'Intel',
    density: 379,
  },
  {
    name: 'Itanium 2 McKinley (64-bit, large cache)',
    number: 220_000_000,
    year: 2002,
    constructor: 'Intel',
    density: 523,
  },
  {
    name: 'DEC Alpha 21364 (64-bit, 946-pin, SIMD, very large caches)',
    number: 152_000_000,
    year: 2003,
    constructor: 'DEC',
    density: 383,
  },
  {
    name: 'Barton (32-bit, large cache)',
    number: 54_300_000,
    year: 2003,
    constructor: 'AMD',
    density: 538,
  },
  {
    name: 'AMD K8 (64-bit, large cache)',
    number: 105_900_000,
    year: 2003,
    constructor: 'AMD',
    density: 548_7,
  },
  {
    name: 'Pentium M Banias (32-bit)',
    number: 77_000_000,
    year: 2003,
    constructor: 'Intel',
    density: 928,
  },
  {
    name: 'Itanium 2 Madison 6M (64-bit)',
    number: 410_000_000,
    year: 2003,
    constructor: 'Intel',
    density: 1_096_000,
  },
  {
    name: 'Pentium 4 Prescott (32-bit, large cache)',
    number: 112_000_000,
    year: 2004,
    constructor: 'Intel',
    density: 1_018_000,
  },
  {
    name: 'Pentium M Dothan (32-bit)',
    number: 144_000_000,
    year: 2004,
    constructor: 'Intel',
    density: 1_655_000,
  },
  {
    name: 'SPARC64 V+ (64-bit, large cache)',
    number: 400_000_000,
    year: 2004,
    constructor: 'Fujitsu',
    density: 1_360_000,
  },
  {
    name: 'Itanium 2 (64-bit;9 MB cache)',
    number: 592_000_000,
    year: 2004,
    constructor: 'Intel',
    density: 1_370_000,
  },
  {
    name: 'Pentium 4 Prescott-2M (32-bit, large cache)',
    number: 169_000_000,
    year: 2005,
    constructor: 'Intel',
    density: 1_182_000,
  },
  {
    name: 'Pentium D Smithfield (64-bit, large cache)',
    number: 228_000_000,
    year: 2005,
    constructor: 'Intel',
    density: 1_107_000,
  },
  {
    name: 'Xenon (64-bit, 128-bit SIMD, large cache)',
    number: 165_000_000,
    year: 2005,
    constructor: 'IBM',
    density: null,
  },
  {
    name: 'Cell (32-bit, cache)',
    number: 250_000_000,
    year: 2005,
    constructor: 'Sony/IBM/Toshiba',
    density: 1_131_000,
  },
  {
    name: 'Pentium 4 Cedar Mill (32-bit, large cache)',
    number: 184_000_000,
    year: 2006,
    constructor: 'Intel',
    density: 2_044_000,
  },
  {
    name: 'Pentium D Presler (64-bit, large cache)',
    number: 362_000_000,
    year: 2006,
    constructor: 'Intel',
    density: 2_235_000,
  },
  {
    name: 'Core 2 Duo Conroe (dual-core 64-bit, large caches)',
    number: 291_000_000,
    year: 2006,
    constructor: 'Intel',
    density: 2_035_000,
  },
  {
    name: 'Dual-core Itanium 2 (64-bit, SIMD, large caches)',
    number: 1_700_000_000,
    year: 2006,
    constructor: 'Intel',
    density: 2_852_000,
  },
  {
    name: 'AMD K10 quad-core 2M L3 (64-bit, large caches)',
    number: 463_000_000,
    year: 2007,
    constructor: 'AMD',
    density: 1_636_000,
  },
  {
    name: 'ARM Cortex-A9 (32-bit, (optional) SIMD, caches)',
    number: 26_000_000,
    year: 2007,
    constructor: 'ARM',
    density: 839,
  },
  {
    name: 'Core 2 Duo Wolfdale (dual-core 64-bit, SIMD, caches)',
    number: 411_000_000,
    year: 2007,
    constructor: 'Intel',
    density: 3_841_000,
  },
  {
    name: 'POWER6 (64-bit, large caches)',
    number: 789_000_000,
    year: 2007,
    constructor: 'IBM',
    density: 2_314_000,
  },
  {
    name: 'Core 2 Duo Allendale (dual-core 64-bit, SIMD, large caches)',
    number: 169_000_000,
    year: 2007,
    constructor: 'Intel',
    density: 1_523_000,
  },
  {
    name: 'Uniphier',
    number: 250_000_000,
    year: 2007,
    constructor: 'Matsushita',
    density: null,
  },
  {
    name: 'SPARC64 VI (64-bit, SIMD, large caches)',
    number: 540_000_000,
    year: 2007,
    constructor: 'Fujitsu',
    density: 1_283_000,
  },
  {
    name: 'Core 2 Duo Wolfdale 3M (dual-core 64-bit, SIMD, large caches)',
    number: 230_000_000,
    year: 2008,
    constructor: 'Intel',
    density: 2_771_000,
  },
  {
    name: 'Core i7 (quad-core 64-bit, SIMD, large caches)',
    number: 731_000_000,
    year: 2008,
    constructor: 'Intel',
    density: 2_779_000,
  },
  {
    name: 'AMD K10 quad-core 6M L3 (64-bit, SIMD, large caches)',
    number: 758_000_000,
    year: 2008,
    constructor: 'AMD',
    density: 2_938_000,
  },
  {
    name: 'Atom (32-bit, large cache)',
    number: 47_000_000,
    year: 2008,
    constructor: 'Intel',
    density: 1_958_000,
  },
  {
    name: 'SPARC64 VII (64-bit, SIMD, large caches)',
    number: 600_000_000,
    year: 2008,
    constructor: 'Fujitsu',
    density: 1_348_000,
  },
  {
    name: 'Six-core Xeon 7400 (64-bit, SIMD, large caches)',
    number: 1_900_000_000,
    year: 2008,
    constructor: 'Intel',
    density: 3_777_000,
  },
  {
    name: 'Six-core Opteron 2400 (64-bit, SIMD, large caches)',
    number: 904_000_000,
    year: 2009,
    constructor: 'AMD',
    density: 2_613_000,
  },
  {
    name: 'SPARC64 VIIIfx (64-bit, SIMD, large caches)',
    number: 760_000_000,
    year: 2009,
    constructor: 'Fujitsu',
    density: 1_481_000,
  },
  {
    name: 'SPARC T3 (16-core 64-bit, SIMD, large caches)',
    number: 1_000_000_000,
    year: 2010,
    constructor: 'Sun/Oracle',
    density: 2_653_000,
  },
  {
    name: 'Six-core Core i7 (Gulftown)',
    number: 1_170_000_000,
    year: 2010,
    constructor: 'Intel',
    density: 4_875_000,
  },
  {
    name: 'POWER7 32M L3 (8-core 64-bit, SIMD, large caches)',
    number: 1_200_000_000,
    year: 2010,
    constructor: 'IBM',
    density: 2_116_000,
  },
  {
    name: 'Quad-core z196 (64-bit, very large caches)',
    number: 1_400_000_000,
    year: 2010,
    constructor: 'IBM',
    density: 2_734_000,
  },
  {
    name: 'Quad-core Itanium Tukwila (64-bit, SIMD, large caches)',
    number: 2_000_000_000,
    year: 2010,
    constructor: 'Intel',
    density: 2_861_000,
  },
  {
    name: 'Xeon Nehalem-EX (8-core 64-bit, SIMD, large caches)',
    number: 2_300_000_000,
    year: 2010,
    constructor: 'Intel',
    density: 3_363_000,
  },
  {
    name: 'SPARC64 IXfx (64-bit, SIMD, large caches)',
    number: 1_870_000_000,
    year: 2011,
    constructor: 'Fujitsu',
    density: 3_864_000,
  },
  {
    name: 'Quad-core + GPU Core i7 (64-bit, SIMD, large caches)',
    number: 1_160_000_000,
    year: 2011,
    constructor: 'Intel',
    density: 5_370_000,
  },
  {
    name: 'Six-core Core i7/8-core Xeon E5  (Sandy Bridge-E/EP) (64-bit, SIMD, large caches)',
    number: 2_270_000_000,
    year: 2011,
    constructor: 'Intel',
    density: 5_230_000,
  },
  {
    name: 'Xeon Westmere-EX (10-core 64-bit, SIMD, large caches)',
    number: 2_600_000_000,
    year: 2011,
    constructor: 'Intel',
    density: 5_078_000,
  },
  {
    name: "Atom 'Medfield' (64-bit)",
    number: 432_000_000,
    year: 2012,
    constructor: 'Intel',
    density: 6_750_000,
  },
  {
    name: 'SPARC64 X (64-bit, SIMD, caches)',
    number: 2_990_000_000,
    year: 2012,
    constructor: 'Fujitsu',
    density: 4_983_000,
  },
  {
    name: 'AMD Bulldozer (8-core 64-bit, SIMD, caches)',
    number: 1_200_000_000,
    year: 2012,
    constructor: 'AMD',
    density: 3_810_000,
  },
  {
    name: 'Quad-core + GPU AMD Trinity (64-bit, SIMD, caches)',
    number: 1_303_000_000,
    year: 2012,
    constructor: 'AMD',
    density: 5_297_000,
  },
  {
    name: 'Quad-core + GPU Core i7 Ivy Bridge (64-bit, SIMD, caches)',
    number: 1_400_000_000,
    year: 2012,
    constructor: 'Intel',
    density: 8_750_000,
  },
  {
    name: 'POWER7+ (8-core 64-bit, SIMD, 80 MB L3 cache)',
    number: 2_100_000_000,
    year: 2012,
    constructor: 'IBM',
    density: 3_704_000,
  },
  {
    name: 'Six-core zEC12 (64-bit, SIMD, large caches)',
    number: 2_750_000_000,
    year: 2012,
    constructor: 'IBM',
    density: 4_606_000,
  },
  {
    name: 'Itanium Poulson (8-core 64-bit, SIMD, caches)',
    number: 3_100_000_000,
    year: 2012,
    constructor: 'Intel',
    density: 5_699_000,
  },
  {
    name: 'Xeon Phi (61-core 32-bit, 512-bit SIMD, caches)',
    number: 5_000_000_000,
    year: 2012,
    constructor: 'Intel',
    density: 6_944_000,
  },
  {
    name: "Apple A7 (dual-core 64/32-bit ARM64, 'mobile SoC', SIMD, caches)",
    number: 1_000_000_000,
    year: 2013,
    constructor: 'Apple',
    density: 9_804_000,
  },
  {
    name: 'Six-core Core i7 Ivy Bridge E (64-bit, SIMD, caches)',
    number: 1_860_000_000,
    year: 2013,
    constructor: 'Intel',
    density: 7_266_000,
  },
  {
    name: 'POWER8 (12-core 64-bit, SIMD, caches)',
    number: 4_200_000_000,
    year: 2013,
    constructor: 'IBM',
    density: 6_462_000,
  },
  {
    name: 'Xbox One main SoC (64-bit, SIMD, caches)',
    number: 5_000_000_000,
    year: 2013,
    constructor: 'Microsoft/AMD',
    density: 13_770_000,
  },
  {
    name: 'Quad-core + GPU Core i7 Haswell (64-bit, SIMD, caches)',
    number: 1_400_000_000,
    year: 2014,
    constructor: 'Intel',
    density: 7_910_000,
  },
  {
    name: "Apple A8 (dual-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 2_000_000_000,
    year: 2014,
    constructor: 'Apple',
    density: 22_470_000,
  },
  {
    name: 'Core i7 Haswell-E (8-core 64-bit, SIMD, caches)',
    number: 2_600_000_000,
    year: 2014,
    constructor: 'Intel',
    density: 7_324_000,
  },
  {
    name: "Apple A8X (tri-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 3_000_000_000,
    year: 2014,
    constructor: 'Apple',
    density: 23_440_000,
  },
  {
    name: 'Xeon Ivy Bridge-EX (15-core 64-bit, SIMD, caches)',
    number: 4_310_000_000,
    year: 2014,
    constructor: 'Intel',
    density: 7_967_000,
  },
  {
    name: 'Xeon Haswell-E5 (18-core 64-bit, SIMD, caches)',
    number: 5_560_000_000,
    year: 2014,
    constructor: 'Intel',
    density: 8_411_000,
  },
  {
    name: 'Quad-core + GPU GT2 Core i7 Skylake K (64-bit, SIMD, caches)',
    number: 1_750_000_000,
    year: 2015,
    constructor: 'Intel',
    density: 14_340_000,
  },
  {
    name: 'Dual-core + GPU Iris Core i7 Broadwell-U (64-bit, SIMD, caches)',
    number: 1_900_000_000,
    year: 2015,
    constructor: 'Intel',
    density: 14_290_000,
  },
  {
    name: "Apple A9 (dual-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 2_000_000_000,
    year: 2015,
    constructor: 'Apple',
    density: 20_800_000,
  },
  {
    name: "Apple A9 (dual-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 2_000_000_000,
    year: 2015,
    constructor: 'Apple',
    density: 19_100_000,
  },
  {
    name: "Apple A9X (dual core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 3_000_000_000,
    year: 2015,
    constructor: 'Apple',
    density: 20_800_000,
  },
  {
    name: 'IBM z13 (64-bit, caches)',
    number: 3_990_000_000,
    year: 2015,
    constructor: 'IBM',
    density: 5_885_000,
  },
  {
    name: 'IBM z13 Storage Controller',
    number: 7_100_000_000,
    year: 2015,
    constructor: 'IBM',
    density: 10_472_000,
  },
  {
    name: 'SPARC M7 (32-core 64-bit, SIMD, caches)',
    number: 10_000_000_000,
    year: 2015,
    constructor: 'Oracle',
    density: null,
  },
  {
    name: "Qualcomm Snapdragon 835 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 3_000_000_000,
    year: 2016,
    constructor: 'Qualcomm',
    density: 41_490_000,
  },
  {
    name: 'Core i7 Broadwell-E (10-core 64-bit, SIMD, caches)',
    number: 3_200_000_000,
    year: 2016,
    constructor: 'Intel',
    density: 13_010_000,
  },
  {
    name: "Apple A10 Fusion (quad-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 3_300_000_000,
    year: 2016,
    constructor: 'Apple',
    density: 26_400_000,
  },
  {
    name: "HiSilicon Kirin 960 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 4_000_000_000,
    year: 2016,
    constructor: 'Huawei',
    density: 36_360_000,
  },
  {
    name: 'Xeon Broadwell-E5 (22-core 64-bit, SIMD, caches)',
    number: 7_200_000_000,
    year: 2016,
    constructor: 'Intel',
    density: 15_790_000,
  },
  {
    name: 'Xeon Phi (72-core 64-bit, 512-bit SIMD, caches)',
    number: 8_000_000_000,
    year: 2016,
    constructor: 'Intel',
    density: 11_710_000,
  },
  {
    name: 'Zip CPU (32-bit, for FPGAs)',
    number: 1_286,
    year: 2016,
    constructor: 'Gisselquist Technology',
    density: null,
  },
  {
    name: "Qualcomm Snapdragon 845 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 5_300_000_000,
    year: 2017,
    constructor: 'Qualcomm',
    density: 56_400_000,
  },
  {
    name: "Qualcomm Snapdragon 850  (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 5_300_000_000,
    year: 2017,
    constructor: 'Qualcomm',
    density: 56_400_000,
  },
  {
    name: "Apple A11 Bionic (hexa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 4_300_000_000,
    year: 2017,
    constructor: 'Apple',
    density: 48_190_000,
  },
  {
    name: 'Zeppelin SoC Ryzen (64-bit, SIMD, caches)',
    number: 4_800_000_000,
    year: 2017,
    constructor: 'AMD',
    density: 25_000_000,
  },
  {
    name: 'Ryzen 5 1600 Ryzen (64-bit, SIMD, caches)',
    number: 4_800_000_000,
    year: 2017,
    constructor: 'AMD',
    density: 22_530_000,
  },
  {
    name: 'Ryzen 5 1600 X Ryzen (64-bit, SIMD, caches)',
    number: 4_800_000_000,
    year: 2017,
    constructor: 'AMD',
    density: 22_530_000,
  },
  {
    name: 'IBM z14 (64-bit, SIMD, caches)',
    number: 6_100_000_000,
    year: 2017,
    constructor: 'IBM',
    density: 8_764_000,
  },
  {
    name: 'IBM z14 Storage Controller (64-bit)',
    number: 9_700_000_000,
    year: 2017,
    constructor: 'IBM',
    density: 13_940_000,
  },
  {
    name: "HiSilicon Kirin 970 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 5_500_000_000,
    year: 2017,
    constructor: 'Huawei',
    density: 56_900_000,
  },
  {
    name: 'Xbox One X (Project Scorpio) main SoC (64-bit, SIMD, caches)',
    number: 7_000_000_000,
    year: 2017,
    constructor: 'Microsoft/AMD',
    density: 19_440_000,
  },
  {
    name: 'Xeon Platinum 8180 (28-core 64-bit, SIMD, caches)',
    number: 8_000_000_000,
    year: 2017,
    constructor: 'Intel',
    density: null,
  },
  {
    name: 'POWER9 (64-bit, SIMD, caches)',
    number: 8_000_000_000,
    year: 2017,
    constructor: 'IBM',
    density: 11_500_000,
  },
  {
    name: 'Freedom U500 Base Platform Chip (E51, 4×U54) RISC-V (64-bit, caches)',
    number: 250_000_000,
    year: 2017,
    constructor: 'SiFive',
    density: 8_330_000,
  },
  {
    name: 'SPARC64 XII (12-core 64-bit, SIMD, caches)',
    number: 5_450_000_000,
    year: 2017,
    constructor: 'Fujitsu',
    density: 6_850_000,
  },
  {
    name: "Apple A10X Fusion (hexa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 4_300_000_000,
    year: 2017,
    constructor: 'Apple',
    density: 44_600_000,
  },
  {
    name: 'Centriq 2400 (64/32-bit, SIMD, caches)',
    number: 18_000_000_000,
    year: 2017,
    constructor: 'Qualcomm',
    density: 45_200_000,
  },
  {
    name: 'AMD Epyc (32-core 64-bit, SIMD, caches)',
    number: 19_200_000_000,
    year: 2017,
    constructor: 'AMD',
    density: 25_000_000,
  },
  {
    name: "HiSilicon Kirin 710 (octa-core ARM64 'mobile SoC', SIMD, caches)",
    number: 5_500_000_000,
    year: 2018,
    constructor: 'Huawei',
    density: null,
  },
  {
    name: "Apple A12 Bionic (hexa-core ARM64 'mobile SoC', SIMD, caches)",
    number: 6_900_000_000,
    year: 2018,
    constructor: 'Apple',
    density: 82_900_000,
  },
  {
    name: "HiSilicon Kirin 980 (octa-core ARM64 'mobile SoC', SIMD, caches)",
    number: 6_900_000_000,
    year: 2018,
    constructor: 'Huawei',
    density: 93_100_000,
  },
  {
    name: "Qualcomm Snapdragon 8cx / SCX8180 (octa-core ARM64 'mobile SoC', SIMD, caches)",
    number: 8_500_000_000,
    year: 2018,
    constructor: 'Qualcomm',
    density: 75_900_000,
  },
  {
    name: "Qualcomm Snapdragon 855 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 6_700_000_000,
    year: 2019,
    constructor: 'Qualcomm',
    density: 91_800_000,
  },
  {
    name: "Qualcomm Snapdragon 865 (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 10_300_000_000,
    year: 2020,
    constructor: 'Qualcomm',
    density: 123_300_000,
  },
  {
    name: "Apple A12X Bionic (octa-core 64/32-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 10_000_000_000,
    year: 2018,
    constructor: 'Apple',
    density: 82_000_000,
  },
  {
    name: 'Fujitsu A64FX (64/32-bit, SIMD, caches)',
    number: 8_786_000_000,
    year: 2018,
    constructor: 'Fujitsu',
    density: null,
  },
  {
    name: 'Tegra Xavier SoC (64/32-bit)',
    number: 9_000_000_000,
    year: 2018,
    constructor: 'Nvidia',
    density: 25_700_000,
  },
  {
    name: 'AMD Ryzen 7 3700X (64-bit, SIMD, caches, I/O die)',
    number: 5_990_000_000,
    year: 2019,
    constructor: 'AMD',
    density: 30_100_000,
  },
  {
    name: 'HiSilicon Kirin 990 4G',
    number: 8_000_000_000,
    year: 2019,
    constructor: 'Huawei',
    density: 89_000_000,
  },
  {
    name: "Apple A13 (hexa-core 64-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 8_500_000_000,
    year: 2019,
    constructor: 'Apple',
    density: 86_300_000,
  },
  {
    name: 'IBM z15 CP chip (12 cores, 256 MB L3 cache)',
    number: 9_200_000_000,
    year: 2019,
    constructor: 'IBM',
    density: 13_220_000,
  },
  {
    name: 'IBM z15 SC chip (960 MB L4 cache)',
    number: 12_200_000_000,
    year: 2019,
    constructor: 'IBM',
    density: 17_530_000,
  },
  {
    name: 'AMD Ryzen 9 3900X (64-bit, SIMD, caches, I/O die)',
    number: 9_890_000_000,
    year: 2019,
    constructor: 'AMD',
    density: 36_230_000,
  },
  {
    name: 'HiSilicon Kirin 990 5G',
    number: 10_300_000_000,
    year: 2019,
    constructor: 'Huawei',
    density: 90_900_000,
  },
  {
    name: 'AWS Graviton2 (64-bit, 64-core ARM-based, SIMD, caches)',
    number: 30_000_000_000,
    year: 2019,
    constructor: 'Amazon',
    density: null,
  },
  {
    name: 'AMD Epyc Rome (64-bit, SIMD, caches)',
    number: 39_540_000_000,
    year: 2019,
    constructor: 'AMD',
    density: 39_226_000,
  },
  {
    name: 'TI Jacinto TDA4VM (ARM A72, DSP, SRAM)',
    number: 3_500_000_000,
    year: 2020,
    constructor: 'Texas Instruments',
    density: null,
  },
  {
    name: "Apple A14 Bionic (hexa-core 64-bit ARM64 'mobile SoC', SIMD, caches)",
    number: 11_800_000_000,
    year: 2020,
    constructor: 'Apple',
    density: 134_100_000,
  },
  {
    name: 'Apple M1 (octa-core 64-bit ARM64 SoC, SIMD, caches)',
    number: 16_000_000_000,
    year: 2020,
    constructor: 'Apple',
    density: 134_500_000,
  },
  {
    name: 'HiSilicon Kirin 9000',
    number: 15_300_000_000,
    year: 2020,
    constructor: 'Huawei',
    density: 134_200_000,
  },
  {
    name: 'AMD Ryzen 7 5800H (64-bit, SIMD, caches, I/O and GPU)',
    number: 10_700_000_000,
    year: 2021,
    constructor: 'AMD',
    density: 59_440_000,
  },
  {
    name: 'Apple A15',
    number: 15_000_000_000,
    year: 2021,
    constructor: 'Apple',
    density: 139_300_000,
  },
  {
    name: 'Apple M1 Pro (10-core, 64-bit)',
    number: 33_700_000_000,
    year: 2021,
    constructor: 'Apple',
    density: 137_600_000,
  },
  {
    name: 'Apple M1 Max (10-core, 64-bit)',
    number: 57_000_000_000,
    year: 2021,
    constructor: 'Apple',
    density: 135_600_000,
  },
  {
    name: 'Power10 dual-chip module (30 SMT8 cores or 60 SMT4 cores)',
    number: 36_000_000_000,
    year: 2021,
    constructor: 'IBM',
    density: 29_900_000,
  },
  {
    name: 'Dimensity 9000 (ARM64 SoC)',
    number: 15_300_000_000,
    year: 2021,
    constructor: 'Mediatek',
    density: null,
  },
  {
    name: 'Apple M1 Ultra (dual-chip module, 2×10 cores)',
    number: 114_000_000_000,
    year: 2022,
    constructor: 'Apple',
    density: 135_600_000,
  },
  {
    name: 'AMD Epyc 7773X (Milan-X) (multi-chip module, 64 cores, 768 MB L3 cache)',
    number: 26_000_000_000,
    year: 2022,
    constructor: 'AMD',
    density: null,
  },
  {
    name: 'IBM Telum dual-chip module (2×8 cores, 2×256 MB cache)',
    number: 45_000_000_000,
    year: 2022,
    constructor: 'IBM',
    density: 42_450_000,
  },
  {
    name: 'Apple M2 (deca-core 64-bit ARM64 SoC, SIMD, caches)',
    number: 20_000_000_000,
    year: 2022,
    constructor: 'Apple',
    density: null,
  },
  {
    name: 'Apple A16 (ARM64 SoC)',
    number: 16_000_000_000,
    year: 2022,
    constructor: 'Apple',
    density: null,
  },
  {
    name: 'Dimensity 9200 (ARM64 SoC)',
    number: 17_000_000_000,
    year: 2022,
    constructor: 'Mediatek',
    density: null,
  },
  {
    name: 'Sapphire Rapids quad-chip module (up to 60 cores and 112.5 MB of cache)',
    number: 48_000_000_000,
    year: 2023,
    constructor: 'Intel',
    density: 30_000_000,
  },
  {
    name: 'Apple M2 Pro (12-core 64-bit ARM64 SoC, SIMD, caches)',
    number: 40_000_000_000,
    year: 2023,
    constructor: 'Apple',
    density: null,
  },
  {
    name: 'Apple M2 Max (12-core 64-bit ARM64 SoC, SIMD, caches)',
    number: 67_000_000_000,
    year: 2023,
    constructor: 'Apple',
    density: null,
  },
].map((item, index) => ({ ...item, id: index }));

export default transistorCPUdata;
